module.exports = __webpack_public_path__ + "img/swiper6.12119b64.jpg";